import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './laodongJiaoyu.module.css';
import shenghuo from '../img/ic_shenghuo.png';
import shengchan from '../img/ic_shengchan.png';
import fuwu from '../img/ic_fuwu.png';
import zili from '../img/ic_laodong_zili.png';
import jiating from '../img/ic_laodong_jiating.png';

import xuexiao from '../img/ic_laodong_school.png';
import shijian from '../img/ic_laodong_shijian.png';
import tuozhan from '../img/ic_laodong_tuozhan.png';

class LaodongJiaoyu extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'clickTab'
        ]);

        this.state = {
            tab: 0
        };

    }

    componentDidMount() {


    }

    clickTab(tab){
        this.setState({
            tab:tab
        })
    }

    render() {
        return (
            <div className={styles.root}>

                <div className={styles["container-tab"]}>
                    <div className={styles["tab-item"]}>
                        <div className={this.state.tab == 0 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                             onClick={this.clickTab.bind(null,0)}
                        >
                            幸福•小当家
                        </div>
                        {this.state.tab == 0 ?
                            <div className={styles.line}></div>
                            : null}
                    </div>
                    <div className={styles["tab-item"]}>
                        <div className={this.state.tab == 1 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                             onClick={this.clickTab.bind(null,1)}
                        >
                            幸福•小工匠
                        </div>
                        {this.state.tab == 1 ?
                            <div className={styles.line}></div>
                            : null}
                    </div>
                    <div className={styles["tab-item"]}>
                        <div className={this.state.tab == 2 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                             onClick={this.clickTab.bind(null,2)}
                        >
                            幸福•小博士
                        </div>
                        {this.state.tab == 2 ?
                            <div className={styles.line}></div>
                            : null}
                    </div>
                    <div className={styles["tab-item"]}>
                        <div className={this.state.tab == 3 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                             onClick={this.clickTab.bind(null,3)}
                        >
                            幸福•小火炬
                        </div>
                        {this.state.tab == 3 ?
                            <div className={styles.line}></div>
                            : null}
                    </div>
                </div>

                {this.state.tab==0?
                    <div className={styles.body}>
                        {
                            this.props.xiaodangjiaList.map((item, index) => {
                                return (
                                    <div className={styles["container-list"]}
                                    >
                                        <div className={styles["container-top"]}>
                                            <img className={styles["img-icon"]}
                                                 src={item.type == '1' ? zili :
                                                     item.type == '2' ? jiating :
                                                         item.type == '3' ? xuexiao :
                                                             item.type == '4' ? shijian :
                                                                 item.type == '5' ? shengchan :
                                                                     item.type == '6' ? tuozhan :
                                                         fuwu}/>
                                            <div className={styles.name}>{item.name}</div>
                                        </div>
                                        <div className={styles["list-warpper"]}>
                                            {
                                                this.props.xiaodangjiaList[index].zhibiao.map((item2) => {
                                                    return (
                                                        <div className={styles["item-liyou"]}
                                                             onClick={this.props.clickLiyou.bind(null,item2.k)}
                                                        >
                                                            {item2.v}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                :null}

                {this.state.tab==1?
                    <div className={styles.body}>
                        {
                            this.props.xiaogongjiangList.map((item, index) => {
                                return (
                                    <div className={styles["container-list"]}
                                    >
                                        <div className={styles["container-top"]}>
                                            <img className={styles["img-icon"]}
                                                 src={item.type == '1' ? zili :
                                                     item.type == '2' ? jiating :
                                                         item.type == '3' ? xuexiao :
                                                             item.type == '4' ? shijian :
                                                                 item.type == '5' ? shengchan :
                                                                     item.type == '6' ? tuozhan :
                                                                         fuwu}/>
                                            <div className={styles.name}>{item.name}</div>
                                        </div>
                                        <div className={styles["list-warpper"]}>
                                            {
                                                this.props.xiaogongjiangList[index].zhibiao.map((item2) => {
                                                    return (
                                                        <div className={styles["item-liyou"]}
                                                             onClick={this.props.clickLiyou.bind(null,item2.k)}
                                                        >
                                                            {item2.v}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    :null}

                {this.state.tab==2?
                    <div className={styles.body}>
                        {
                            this.props.xiaoboshiList.map((item, index) => {
                                return (
                                    <div className={styles["container-list"]}
                                    >
                                        <div className={styles["container-top"]}>
                                            <img className={styles["img-icon"]}
                                                 src={item.type == '1' ? zili :
                                                     item.type == '2' ? jiating :
                                                         item.type == '3' ? xuexiao :
                                                             item.type == '4' ? shijian :
                                                                 item.type == '5' ? shengchan :
                                                                     item.type == '6' ? tuozhan :
                                                                         fuwu}/>
                                            <div className={styles.name}>{item.name}</div>
                                        </div>
                                        <div className={styles["list-warpper"]}>
                                            {
                                                this.props.xiaoboshiList[index].zhibiao.map((item2) => {
                                                    return (
                                                        <div className={styles["item-liyou"]}
                                                             onClick={this.props.clickLiyou.bind(null,item2.k)}
                                                        >
                                                            {item2.v}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    :null}


                {this.state.tab==3?
                    <div className={styles.body}>
                        {
                            this.props.xiaohuojuList.map((item, index) => {
                                return (
                                    <div className={styles["container-list"]}
                                    >
                                        <div className={styles["container-top"]}>
                                            <img className={styles["img-icon"]}
                                                 src={item.type == '1' ? zili :
                                                     item.type == '2' ? jiating :
                                                         item.type == '3' ? xuexiao :
                                                             item.type == '4' ? shijian :
                                                                 item.type == '5' ? shengchan :
                                                                     item.type == '6' ? tuozhan :
                                                                         fuwu}/>
                                            <div className={styles.name}>{item.name}</div>
                                        </div>
                                        <div className={styles["list-warpper"]}>
                                            {
                                                this.props.xiaohuojuList[index].zhibiao.map((item2) => {
                                                    return (
                                                        <div className={styles["item-liyou"]}
                                                             onClick={this.props.clickLiyou.bind(null,item2.k)}
                                                        >
                                                            {item2.v}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    :null}


            </div>
        );
    }
}


export default LaodongJiaoyu;
